import { writable, type Readable } from 'svelte/store';

export interface ReloadableStore<T> extends Readable<Promise<T>> {
	reload: () => void;
}
export function reloadableStore<T>(load: () => Promise<T>): ReloadableStore<T> {
	const store = writable<Promise<T>>();
	const reloadable = {
		subscribe: store.subscribe,
		reload: () => store.set(load()),
	};
	reloadable.reload();
	return reloadable;
}

export function unwrap<T>(reloadableStore: ReloadableStore<T>): Readable<T | undefined> {
	const valueStore = writable<T | undefined>();
	reloadableStore.subscribe((promise) => {
		valueStore.set(undefined);
		promise.then((val) => valueStore.set(val));
	});
	return valueStore;
}
